import { useMemo } from 'react';
import GtfsClient, { IGtfsClient } from '../api_clients/gtfs';
import { getValidToken } from '../auth/auth';
import useUserStore from '../store/user';

const GTFS_URLS: Record<string, string> = {
  'region-vastmanland': 'https://gtfs.vl.allbin.se',
  'region-sormland': 'https://gtfs-trafiklab-adapter.allbin.se/sormland',
  'region-vasterbotten':
    'https://gtfs-trafiklab-adapter.allbin.se/vasterbotten',
};

export const useGtfsClient = (): IGtfsClient | null => {
  const tenant = useUserStore((state) => state.tenant);

  const baseUrl = tenant ? GTFS_URLS[tenant] : undefined;

  return useMemo<IGtfsClient | null>(() => {
    if (!baseUrl) {
      return null;
    }
    return GtfsClient({
      baseUrl,
      token: getValidToken,
    });
  }, [baseUrl]);
};
